module.exports = __webpack_public_path__ + "img/rincontravel2.11265e17.png";